import { createSlice, type PayloadAction } from "@reduxjs/toolkit/react";
import { type Account, type AppResponse, type Page } from "./api.types";
import { loadLocal } from "./persist";

export type LocalState = {
  appSlug: string | null;
  appSlugNext: string | null;
  orgSlug: string | null;
};

const initialState: LocalState = {
  appSlugNext: null,
  ...loadLocal(),
};

export const local = createSlice({
  name: "local",
  initialState,
  reducers: {
    reset: (): LocalState => {
      return { appSlug: null, appSlugNext: null, orgSlug: null };
    },
    set: (
      state: LocalState,
      action: PayloadAction<Partial<LocalState>>,
    ): LocalState => {
      return { ...state, ...action.payload };
    },
    handleAccount: (
      state: LocalState,
      action: PayloadAction<Account>,
    ): LocalState => {
      const orgs = action.payload.organizations;
      if (!orgs.length) {
        return { ...state, orgSlug: null };
      }
      const org = orgs.find((o) => o.slug === state.orgSlug);
      if (org) {
        return { ...state, orgSlug: org.slug };
      }
      return { ...state, orgSlug: orgs[0].slug };
    },
    handleApps: (
      state: LocalState,
      action: PayloadAction<Page<AppResponse>>,
    ): LocalState => {
      const apps = action.payload.data;
      if (!apps.length) {
        return { ...state, appSlug: null, appSlugNext: null };
      }
      if (apps.some((a) => a.slug === state.appSlugNext)) {
        return { ...state, appSlug: state.appSlugNext, appSlugNext: null };
      }
      if (apps.some((a) => a.slug === state.appSlug)) {
        return { ...state, appSlug: state.appSlug, appSlugNext: null };
      }
      const defaultApp = apps.find((app) => !app.is_sandbox) ?? apps[0];
      return { ...state, appSlug: defaultApp.slug, appSlugNext: null };
    },
  },
});
